/**
 * @file DeleteCustomer.js is responsible for rendering the delete customer modal
 */
import React, { useState } from "react";

import { 
	Button, 
	Modal, 
	ModalOverlay, 
	ModalContent, 
	ModalHeader, 
	ModalFooter, 
	ModalBody, 
	ModalCloseButton,
	Text,
	Input,
	Alert,
	AlertIcon,
	AlertDescription,
} from "@chakra-ui/react";

import useDeleteCustomer from "hooks/Customer/mutations/useDeleteCustomer";

/**
 * @function DeleteCustomer
 * @summary - Modal to delete a customer
 */
const DeleteCustomer = ({ isOpen, onClose, customer, refetch }) => {

	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState(null);

	const [confirmText, setConfirmText] = useState("");

	const { deleteCustomer } = useDeleteCustomer();

	/**
	 * @function handleDeleteCustomer
	 * 
	 * @description - This function is used to delete a customer from the database.
	 * 
	 */
	const handleDeleteCustomer = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		setLoading(true);

		let response = await deleteCustomer(customer._id);
		if(response.error) {
			setErrorMsg(response.error.message);
			setLoading(false);
			return;
		}
		if(response.success) {
			refetch();
			onClose();
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Delete Customer</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Text>Are you sure you want to delete this customer?</Text>
					<Text fontWeight="bold" mt={2}>This action cannot be undone.</Text>
					{errorMsg && (
						<Alert status="error">
							<AlertIcon />
							<AlertDescription>{errorMsg}</AlertDescription>
						</Alert>
					)}
					<Text mt={4}>Please type <Text as="span" fontWeight="bold">DELETE</Text> to confirm.</Text>
					<Input
						mt={2}
						placeholder="DELETE"
						value={confirmText}
						onChange={(e) => setConfirmText(e.target.value)}
					/>
				</ModalBody>
				<ModalFooter>
					<Button
						variant="primary"
						mr={3}
						onClick={handleDeleteCustomer}
						isLoading={loading}
						isDisabled={confirmText !== "DELETE"}
					>
						Delete
					</Button>
					<Button variant="ghost" onClick={onClose}>
						Cancel
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default DeleteCustomer;

